<script>
	export let toast;
	import Button from "./Button.svelte";

	$: alertClass = {
		"": "",
		neutral: "alert-neutral",
		primary: "alert-primary",
		secondary: "alert-secondary",
		accent: "alert-accent",
		success: "alert-success",
		info: "alert-info",
		warning: "alert-warning",
		error: "alert-error",
	}[toast.className];

	function refreshBroswer() {
		location.reload();
	}
</script>

<div class="alert {alertClass} z-50">
	<span>{toast.text}</span>
	{#if toast.id === "___refresh___"}
		<Button on:click={refreshBroswer} size="xs">Refresh</Button>
	{/if}
</div>
